import { forwardRef, type HTMLAttributes } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

/**
 * Tag — 작은 상태 칩. styles.css `.tag-*` 매핑.
 * 5 variant: default · primary · accent · success · warn
 */
const tagStyles = cva(
  [
    'inline-flex items-center gap-1',
    'px-2.5 py-1 rounded-full',
    'text-[11px] font-semibold leading-none',
  ],
  {
    variants: {
      variant: {
        default: 'bg-surface-alt text-text-2',
        primary: 'bg-primary-soft text-primary',
        accent: 'bg-accent-soft text-accent-deep',
        success: 'bg-success-soft text-success-deep',
        warn: 'bg-warning-soft text-warning-deep',
        error: 'bg-error-soft text-error-deep',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface TagProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof tagStyles> {}

export const Tag = forwardRef<HTMLSpanElement, TagProps>(
  ({ className, variant, ...rest }, ref) => (
    <span ref={ref} className={cn(tagStyles({ variant }), className)} {...rest} />
  ),
)
Tag.displayName = 'Tag'
